import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import PortfolioItem from "./../components/portfolioItem";
import SectionContent from "./../scripts/sectionContent";

const Portfolio = () => {

    const data = useStaticQuery(graphql`
        query portfolioSectionQuery {
            allContentfulSectionContent(filter: {section: {eq: "Portfolio"}, page: {eq: "Homepage"}}) {
                edges {
                    node {
                        id
                        content {
                            childMarkdownRemark {
                                html
                                rawMarkdownBody
                            }
                        }
                        contentType
                    }
                }
            }
            allContentfulPortfolio {
                edges {
                    node {
                        id
                        title
                        company
                        websiteUrl
                        overview {
                            childContentfulRichText {
                                html
                            }
                        }
                        thumbnailImage {
                            fluid(quality: 100) {
                                src
                            }
                        }
                        image {
                            fluid(quality: 100 maxWidth: 527 maxHeight:376 ) {
                                src
                            }
                        },
                        techStack
                    }
                }
            }
        }
    `);

    const sectionContent = new SectionContent(data.allContentfulSectionContent);

    return (
        <section id="portfolio" className="portfolio section col container mx-auto text-center">
            <div className="col w-full md:w-1/2 mx-auto">
                <h3 className="section__heading mx-auto mb-4">{ sectionContent.getContent('heading').rawMarkdownBody }</h3>
                <p className="mb-16">{ sectionContent.getContent('description').rawMarkdownBody }</p>
            </div>
            <div className="w-full mx-auto">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-4">
                    {
                        data.allContentfulPortfolio.edges.map(edge => (
                            <PortfolioItem portfolio={edge.node} key={ edge.node.id }/>
                        ))
                    }               
                </div>
            </div> 
        </section>
    );
}

export default Portfolio;